import { toast } from "react-toastify";
import axiosConfig from "../axiosConfig.js";


class SelfServiceFormService {
    addUpdateSurgeryCenterSelfService = async (requestBody) => {
        let errorMessage;
        try {
            const response = await axiosConfig.post("SurgeryCenter/SurgeryCenterRegistration", requestBody, { headers: { 'Content-Type': 'multipart/form-data' } });
            return response;
        } catch (error) {
            errorMessage = error?.message || "Self service not add"; // Fallback message
        }finally{
            toast.error(errorMessage);
        }
    };
}

const instance = new SelfServiceFormService();

export default instance;
